import { Injectable } from '@angular/core';
import { TooltipRow } from '../shared';
import { chain, groupBy, keys, uniq, isNil } from 'lodash';
import { DataRevisionIndicator } from '../shared';
import { LabTestResult } from '../lab-test-results';
import { OnScreenResults } from './on-screen-results';

@Injectable()
export class OnScreenResultsRenderer {

    constructor(private dataRevisionIndicator: DataRevisionIndicator) { }

    public getValue<TEntity extends OnScreenResults>(
        entity: TEntity,
        valueGetter: (value: TEntity) => string,
        detailsCancellationReason: boolean = false): string {

        if (!entity) {
            return null;
        }

        let result: string;
        if (entity.isCancelled) {
            result = 'cancelled';
            if (detailsCancellationReason) {
                result += `\n${entity.cancellationReason}`;
            }
        } else {
            result = valueGetter(entity);
        }

        return result;
    }

    public getLabTestResultsRenderData(labTestResults: LabTestResult[]): LabTestResultData[] {
        const data = labTestResults.map((labTestResult: LabTestResult) => {
            const result = labTestResult.currentResult;

            const labTestResultData = new LabTestResultData();
            labTestResultData.isFlagged = labTestResult.isFlagged;
            labTestResultData.isCancelled = labTestResult.isCancelled;
            labTestResultData.hasResultDataRevision = labTestResult.hasResultDataRevision;
            labTestResultData.hasSubjectDataRevision = labTestResult.hasSubjectDataRevision;
            labTestResultData.hasVisitDataRevision = labTestResult.hasVisitDataRevision;

            if (labTestResultData.isCancelled) {
                labTestResultData.details.push({ title: 'Cancellation Reason', value: labTestResult.cancellationReason });
            } else {

                const stringRes = !isNil(result) ? result.stringResult : '';
                labTestResultData.displayValue = stringRes;
                labTestResultData.details.push({ title: 'Value', value: stringRes });                    
            }

            if (labTestResultData.hasResultDataRevision) {
                labTestResultData.details.push({ title: 'Revision', value: this.dataRevisionIndicator.resultDataRevisionMessage });
            }

            return labTestResultData;
        });

        return data;
    }
}

export class LabTestResultData {
    public displayValue: string;
    public isFlagged: boolean;
    public isCancelled: boolean;
    public hasResultDataRevision: boolean;
    public hasVisitDataRevision: boolean;
    public hasSubjectDataRevision: boolean;
    public details: TooltipRow[] = [];

    public get text() {
        return this.details
            .map(d => `${d.title}: ${d.value}`)
            .join('\n');
    }
}